import { Amplify, Auth } from "aws-amplify";
import awsExports from "aws-exports";

Amplify.configure({
  Auth: {
    region: awsExports.aws_project_region,
    identityPoolId: awsExports.aws_cognito_identity_pool_id,
    userPoolId: awsExports.aws_user_pools_id,
    userPoolWebClientId: awsExports.aws_user_pools_web_client_id,
    mandatorySignIn: true,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
});

export const getUser = () => Auth.currentAuthenticatedUser({ bypassCache: false });
export const signIn = (username, password) => Auth.signIn(username, password);
export const signOut = () => Auth.signOut();
